import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import ColumnMenuContext from './ColumnMenuContext';

function InvoiceNoCell({ colSpan, dataItem, field, className, ariaColumnIndex, style }) {
  const { showQbInvoiceNumberColumn } = useContext(ColumnMenuContext);
  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected="false"
      style={style}>
      <div className="table__contents--multi-val">
        {dataItem[`${field}Path`] ? <a href={dataItem[`${field}Path`]}>{dataItem[field]}</a> : dataItem[field]}

        {!showQbInvoiceNumberColumn && dataItem.qboInvoiceId && dataItem.showQbIcons && (
          <span className="--qbo">
            <img
              height="16"
              width="16"
              alt={translate('quick_books', { namespace: 'quick_books.generic' })}
              src="/qbo.svg"
              className="custom-icon--qbo"
              title={translate('quick_books', { namespace: 'quick_books.generic' })}
            />
            {dataItem.qboInvoiceId}
          </span>
        )}
      </div>
    </td>
  );
}

InvoiceNoCell.propTypes = {
  colSpan: PropTypes.number.isRequired,
  dataItem: PropTypes.shape({
    path: PropTypes.string,
    id: PropTypes.number,
    qboInvoiceId: PropTypes.string,
    showQbIcons: PropTypes.bool
  }).isRequired,
  field: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  ariaColumnIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};

export default InvoiceNoCell;
